import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as _ from 'lodash';
import { Router } from '@angular/router';

import { BoardEvaluationExecutionService } from '../../../../services/boardEvaluationExecution.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { ConfirmationPopupComponent } from '../../confirmation-popup/confirmation-popup.component';

declare var $: any;
declare var jQuery: any;

@Component({
  selector: 'app-view-overall-questions',
  templateUrl: './view-overall-questions.component.html',
  styleUrls: ['./view-overall-questions.component.css'],
})
export class ViewOverallQuestionsComponent implements OnInit {
  @Input('criteriaList') criteriaList: any;
  @Input('question') question: any;
  @Input('criteriaName') criteriaName: any;
  @Input('scoreRange') scoreRange: any;
  @Input('scoreParticularDetails') scoreParticularDetails: any;
  @Input('answerDetails') answerDetails: any;
  @Input('assignedFormId') assignedFormId: any;
  @Input('formAnonymous') formAnonymous: any;
  @Input('IsFormEvaluated') IsFormEvaluated: any;
  @Input('isNextButtonEnabled') isNextButtonEnabled : any;
  @Input('comments') comments : any;
  @Input('assesseeListToExecute') assesseeListToExecute : any;
  @Output() changedStatus = new EventEmitter();
  @Output() commentChangeStatus = new EventEmitter();

  scoreRangeObject: any = [];
  public emitObject: any;
  public submitBtnStatus: boolean = false;
  public answerStatus: any;
  public hidePreviousButton: boolean;
  public hideNextButton: boolean;
  public viewsubmitQuestionBtnStatus: boolean = false;
  totalQuestion: any = 0;
  answerComments: any;
  answerScore: Number;
  answeredCount: any = 0;
  showSpinner: boolean = false;
  commentEnable: any;
  overallComments: any;
  subscribe: Subscription;
  answerListAsPerAssesseeList: any = [];
  enableNextButton: Boolean = false;

  constructor(
    public boardExecutionService: BoardEvaluationExecutionService,
    private router: Router,
    private modalService: NgbModal
  ) {
    this.submitBtnStatus = false;
    this.answerStatus = 'Not Answrered';
    this.hidePreviousButton = false;
    this.hideNextButton = false;
    this.emitObject = {
      status: '',
      buttonClick: '',
      questionid: '',
      response: '',
      criteriaId: '',
    };

    console.log('contrcutor');
    this.overallComments = {
      Comments: '',
      evaluationFormId: '',
      assesseeId: '',
    };
  }

  ngOnInit() {
    this.initialiseSubjectSubscription();
    // console.log("assesseeListToExecute", this.assesseeListToExecute , this.criteriaName, this.formAnonymous)
  }

  returnAnswerStructure(
    questionId,
    answerScore,
    criteriaId,
    assesseeId,
    assesseeName,
    evaluationFormId,
    answeredStatus,
    IsFormEvaluated,
    IsAnonymous,
    Comments
  ) {
    return {
      questionId: questionId,
      AnswerScore: answerScore,
      CriteriaId: criteriaId,
      assesseeId: assesseeId,
      assesseeName: assesseeName,
      evaluationFormId: evaluationFormId,
      answeredStatus: answeredStatus,
      IsFormEvaluated: IsFormEvaluated,
      IsAnonymous: IsAnonymous,
      Comments: Comments,
    };
  }

  async initialiseSubjectSubscription() {
    this.subscribe =
      await this.boardExecutionService.commentsObservable.subscribe((res) => {
        this.commentEnable = res;
      });
  }

  ngOnChanges(event) {
    var self = this;
    var index1;
    this.scoreRange = this.scoreRange;
    this.scoreParticularDetails = this.scoreParticularDetails;

    // console.log("criteria , questio", this.criteriaName , this.question)

    //console.log("scoreParticularDetails=================+", this.scoreParticularDetails)
    var i = 0;
    for (i; i < this.scoreRange; i++) {
      this.scoreRangeObject.push({ label: i + 1, value: i + 1, index: i });
    }
    _.forEach(self.scoreParticularDetails, function (selecteddata) {
      index1 = _.findIndex(self.scoreRangeObject, function (object) {
        return _.get(object, 'index') == _.get(selecteddata, 'index');
      });
      self.scoreRangeObject[index1].data = selecteddata.scoreValue;
    });
    this.scoreRangeObject = _.uniqBy(this.scoreRangeObject, 'value');

    this.bindAnswersToValue();
    this.checkAllQuestionsAnswered();

    this.enableSubmitButton();

    // console.log("event",event)

    if (
      !_.isUndefined(event.assesseeListToExecute) &&
      !_.isUndefined(event.assesseeListToExecute.currentValue)
    ) {
      if (Array.isArray(event.assesseeListToExecute.currentValue)) {
        // console.log("this.overallComments",this.overallComments)
        if (
          !_.isUndefined(this.overallComments.evaluationFormId) &&
          this.overallComments.evaluationFormId != ''
        ) {
          var found = event.assesseeListToExecute.currentValue.findIndex(
            (element) => {
              return element.AssesseeId == this.overallComments.assesseeId;
            }
          );
          // console.log("found",found)

          if (found >= 0) {
            var commentRadio: any = document.getElementsByName('comments');
            //  console.log("commentRadio",commentRadio)
            setTimeout(() => {
              commentRadio.forEach((element: HTMLInputElement) => {
                if (element.value == this.overallComments.assesseeId) {
                  //  console.log("element - checked",true)
                  element.checked = true;
                }
              });
            }, 0);
          }
        } else {
          // var firstElement = event.assesseeListToExecute.currentValue[0]
          // // console.log("firstElement",firstElement)
          // this.overallComments.assesseeId = firstElement.AssesseeId
          // this.overallComments.evaluationFormId  = firstElement._id,
          // this.overallComments.Comments = firstElement.Comments
          // setTimeout(() => {
          //   var commentRadio : any =  document.getElementsByName("comments")
          //   // console.log("commentRadio",commentRadio)
          //   commentRadio.forEach((element : HTMLInputElement) => {
          //     if(element.value == this.overallComments.assesseeId){
          //     //  console.log("element - checked",true)
          //       element.checked = true;
          //     }
          //   })
          //  }, 200);
        }
      }
    }
  }

  changedAnswerScore($event, score, assessee) {
    if (score.value > 0) {
      assessee.answeredStatus = 'Answered';
    } else {
      assessee.answeredStatus = null;
    }

    this.checkAllQuestionsAnswered();
    // console.log("this.", this.answerListAsPerAssesseeList)
  }

  assesseeAnswerBind(assessee) {
    // console.log("assessee",assessee)
  }

  bindValueToControl(assessee, question, subcount) {
    // console.log("assessee , question ,subcount",assessee , question ,subcount)
  }

  ngOnDestroy() {
    this.boardExecutionService.commentsEvent$.next(false);
    this.subscribe.unsubscribe();
  }

  bindAnswersToValue() {
    this.answerListAsPerAssesseeList = [];

    if (!_.isUndefined(this.assesseeListToExecute)) {
      this.assesseeListToExecute.forEach((element) => {
        if (_.size(element.Answers) > 0) {
          var found = _.findIndex(element.Answers, (answerElement) => {
            return (
              _.get(answerElement, 'QuestionId') == this.question._id &&
              _.get(answerElement, 'EvaluationCriteriaId') ==
                this.criteriaName._id
            );
          });
          if (found < 0) {
            this.answerListAsPerAssesseeList.push(
              this.returnAnswerStructure(
                this.question._id,
                0,
                this.criteriaName._id,
                element.AssesseeId,
                element.newAssesseDetails,
                element._id,
                null,
                element.IsFormEvaluated,
                element.EvaluationFormId.IsAnonymous,
                element.Comments ? element.Comments : ''
              )
            );
          } else {
            this.answerListAsPerAssesseeList.push(
              this.returnAnswerStructure(
                this.question._id,
                parseInt(element.Answers[found].AnswerScore),
                this.criteriaName._id,
                element.AssesseeId,
                element.newAssesseDetails,
                element._id,
                element.Answers[found].AnswerStatus,
                element.IsFormEvaluated,
                element.EvaluationFormId.IsAnonymous,
                element.Comments ? element.Comments : ''
              )
            );
          }
        } else {
          this.answerListAsPerAssesseeList.push(
            this.returnAnswerStructure(
              this.question._id,
              0,
              this.criteriaName._id,
              element.AssesseeId,
              element.newAssesseDetails,
              element._id,
              null,
              element.IsFormEvaluated,
              element.EvaluationFormId.IsAnonymous,
              element.Comments ? element.Comments : ''
            )
          );
        }
      });
    }
  }

  confirmSubmitEvaluationExecution() {
    $('#submitEvaluationModal').modal('toggle');
  }

  navigateToSubmittedQuestion() {}

  next(event) {
    this.showSpinner = true;

    this.boardExecutionService
      .answerOverallEvaluationFormExecution(this.answerListAsPerAssesseeList)
      .then((res) => {
        // console.log("res", res)
        this.emitObject.questionid = this.question._id;
        this.emitObject.criteriaId = this.criteriaName._id;
        this.emitObject.response = res;
        this.emitObject.status = 'Answered';
        this.emitObject.buttonClick = 'next';

        this.changedStatus.emit(this.emitObject);

        this.showSpinner = false;

        this.enableSubmitButton();
        if (this.submitBtnStatus) {
          const modalRef = this.modalService.open(ConfirmationPopupComponent, {
            backdrop: 'static',
          });
          modalRef.componentInstance.Message = 'You can now Submit Evaluation';
          modalRef.result.then(
            (resp) => {},
            (error) => {}
          );
        }
      });
  }

  checkAllQuestionsAnswered() {
    var found = _.findIndex(this.answerListAsPerAssesseeList, (element) => {
      return _.get(element, 'answeredStatus') != 'Answered';
    });

    if (found >= 0) {
      this.enableNextButton = false;
    } else {
      this.enableNextButton = true;
    }

    if (this.enableNextButton) {
      var foundElement = _.findIndex(
        this.answerListAsPerAssesseeList,
        (element) => {
          return _.get(element, 'IsFormEvaluated') != true;
        }
      );
      if (foundElement >= 0) {
        this.enableNextButton = true;
      } else {
        this.enableNextButton = false;
        this.IsFormEvaluated = true;
      }
    }
  }

  enableSubmitButton() {
    if (!_.isUndefined(this.assesseeListToExecute)) {
      var totalAssessee = _.size(this.assesseeListToExecute);
      var totalNumberOfQuestions = 0;
      var element = this.assesseeListToExecute[0];

      element.EvaluationFormId.EvaluationCriterias.forEach(
        (criteriaElement) => {
          // console.log("criteriaElement",criteriaElement)
          totalNumberOfQuestions =
            totalNumberOfQuestions + _.size(criteriaElement.EvaluationQuestion);
        }
      );

      totalNumberOfQuestions = totalNumberOfQuestions * totalAssessee;

      var totalAnsweredQuestions = 0;

      this.assesseeListToExecute.forEach((element) => {
        totalAnsweredQuestions =
          totalAnsweredQuestions + _.size(element.Answers);
      });

      if (totalNumberOfQuestions == totalAnsweredQuestions) {
        this.submitBtnStatus = true;
        this.assesseeListToExecute.forEach((element) => {
          element.Answers.forEach((answerElement) => {
            if (answerElement.AnswerStatus != 'Answered') {
              this.submitBtnStatus = false;
            }
          });
        });
      } else {
        this.submitBtnStatus = false;
      }
    }

    // console.log("totalNumberOfQuestions",totalNumberOfQuestions, this.assesseeListToExecute, totalAnsweredQuestions, this.submitBtnStatus)
  }

  submitEvaluationExecution() {
    // console.log("answerListAsPerAssesseeList", this.answerListAsPerAssesseeList)

    this.showSpinner = true;
    $('#submitEvaluationModal').modal('toggle');
    var userInfo = JSON.parse(localStorage.getItem('user'));

    var objectArray = [];

    this.answerListAsPerAssesseeList.forEach((element) => {
      objectArray.push({
        "formId": element.evaluationFormId,
        "IsAnonymous": element.IsAnonymous,
        "AssigneeId": userInfo._id
      })
    })


    this.boardExecutionService.submitOverAllEvaluationExecutionForm(objectArray).then(res => {
      // console.log("res",res)
      this.showSpinner = false;
      $('#alertTitle').text("Success!");
      $('#alertTitle').css("color", "black");
      $('#alertMessage').text(res.message);
      $('#alertMessage').css("color", "black");
      $('#messagePopUp').modal('toggle');
      this.messagePopUpTimeoutToogle();
      //this.router.navigate(['structure', { outlets: { 'structure-outlet': ['evaluationFormList'] } }]);
      this.router.navigate(['structure', { outlets: { 'structure-outlet': ['individualReportList'] } }]);
    })

  }

  messagePopUpTimeoutToogle() {
    setTimeout(function () {
      var popUpClass = $('#messagePopUp').attr('class');
      if (popUpClass == 'modal fade show') {
        $('#messagePopUp').modal('toggle');
      }
    }, 3000);
  }

  closeForm(id) {
    $('#' + id).modal('toggle');
    this.ngOnInit();
  }

  changeUserForComments(event, assessee) {
    this.overallComments = {
      Comments: assessee.Comments,
      evaluationFormId: assessee.evaluationFormId,
      assesseeId: assessee.assesseeId,
    };
  }

  submitComments() {
    var commentsObject = {
      _id: this.overallComments.evaluationFormId,
      Comments: this.overallComments.Comments,
    };
    this.showSpinner = true;
    if (
      _.isUndefined(this.overallComments.evaluationFormId) ||
      this.overallComments.evaluationFormId == ''
    ) {
      this.showSpinner = false;
      return;
    }

    this.boardExecutionService.submitComments(commentsObject).then((res) => {
      var objectToSend = [];
      this.answerListAsPerAssesseeList.forEach((element) => {
        objectToSend.push({
          assesseeId: element.assesseeId,
          executionFormId: element.evaluationFormId,
        });
      });
      this.boardExecutionService
        .getAssignedEvalutionFormDetailsByArrayOfId(objectToSend)
        .then((res) => {
          this.showSpinner = false;
          this.commentChangeStatus.emit(res);
        });
    });
  }
}
